var _circle, _path, _path2;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRecurringGray = function SvgRecurringGray(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#F7F9FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9998 6.00033C8.68613 6.00033 5.99984 8.68662 5.99984 12.0003C5.99984 15.314 8.68613 18.0003 11.9998 18.0003C15.3135 18.0003 17.9998 15.314 17.9998 12.0003C17.9998 11.6321 18.2983 11.3337 18.6665 11.3337C19.0347 11.3337 19.3332 11.6321 19.3332 12.0003C19.3332 16.0504 16.0499 19.3337 11.9998 19.3337C7.94975 19.3337 4.6665 16.0504 4.6665 12.0003C4.6665 7.95024 7.94975 4.66699 11.9998 4.66699C14.5598 4.66699 16.8129 5.97922 18.1237 7.9646C18.3266 8.27187 18.2419 8.6854 17.9347 8.88827C17.6274 9.09113 17.2139 9.0065 17.011 8.69924C15.9365 7.07175 14.0931 6.00033 11.9998 6.00033Z",
    fill: "#576777"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 4.66699C18.3682 4.66699 18.6667 4.96547 18.6667 5.33366V8.66699C18.6667 9.03518 18.3682 9.33366 18 9.33366H14.6667C14.2985 9.33366 14 9.03518 14 8.66699C14 8.2988 14.2985 8.00033 14.6667 8.00033H17.3333V5.33366C17.3333 4.96547 17.6318 4.66699 18 4.66699Z",
    fill: "#576777"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRecurringGray, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/recurring-gray.0ab176fc.svg";
export { ForwardRef as ReactComponent };